module.exports = __webpack_public_path__ + "static/Webnyay Mediation & Conciliation Rules 2020-fef1439569969155aa92abbd751129cb.pdf";